// extracted by mini-css-extract-plugin
module.exports = {"lightTheme":"nvrt-light_theme","darkTheme":"nvrt-dark_theme","logo":"logo_logo__2E-82","title":"logo_title__4MblK"};